import Index from '../components/RecipeOrder/Index';

let routes = {
    path: '/recipeOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/recipeOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/recipeOrder.js